var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isModalVisible
    ? _c("modal", {
        attrs: { width: _vm.width, height: _vm.height },
        on: {
          "hide-modal": function ($event) {
            return _vm.hideModal()
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "text-wrapper" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-center" },
                        [
                          _c("error-state-icon", {
                            attrs: { iconType: "error" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "h3",
                        {
                          staticClass: "text-center bold",
                          attrs: { id: "modal-title" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.webstoreContent.webstoreAlerts
                                .hardware_only_modal.title
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "text-center",
                          attrs: { id: "modal-description" },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.webstoreContent.webstoreAlerts
                                    .hardware_only_modal.text
                                ) +
                                "\n                "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-button", {
                        attrs: {
                          position: "center",
                          mobile: "11",
                          tablet: "9",
                          desktop: "9",
                          styling: "primary rounded mt-1/2",
                          textAlign: "center",
                          disabled: false,
                        },
                        on: {
                          onClickEvent: function ($event) {
                            return _vm.continueWithOrder()
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.webstoreContent.webstoreAlerts
                                            .hardware_only_modal.button1
                                        ) +
                                        "\n                    "
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1744199166
                        ),
                      }),
                      _vm._v(" "),
                      _c("v-button", {
                        attrs: {
                          position: "center",
                          mobile: "11",
                          tablet: "9",
                          desktop: "9",
                          styling: "secondary rounded",
                          textAlign: "center",
                          disabled: false,
                        },
                        on: {
                          onClickEvent: function ($event) {
                            _vm.hideLicenses
                              ? _vm.licensePurchaseRequest()
                              : _vm.handleCloseModal()
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.hideLicenses
                                            ? _vm.webstoreContent.webstoreAlerts
                                                .hardware_only_modal.button2
                                            : "Add licenses"
                                        ) +
                                        "\n                    "
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1479976697
                        ),
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          3302750075
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }